import EtHeader from "@/components/navigation/EtHeader";
import EtHero from "@/components/navigation/EtHero";
import EtFooter from "@/components/navigation/EtFooter";

import EtTrinityAdvantage from "@/components/sections/EtTrinityAdvantage";
import EtHowItWorks from "@/components/sections/EtHowItWorks";
import EtTestimonials from "@/components/sections/EtTestimonials";
import EtCallToAction from "@/components/sections/EtCallToAction";
import EtAbout from "@/components/sections/EtAbout";
import EtContact from "@/components/sections/EtContact";

// 29 Oct 2025
import {useState, useEffect} from "react"

export default function EtTrinityHome() {
  // First Created - 15 Aug 2025
  // Author - Atul Pandey
  // Updated - 29 Oct 2025 - added state for showing other sections for Hero component
  // Updated - 31 Oct 2025 - added state for showing other sections after the approach sections
  // Updated - 02 Nov 2025 - added timer for showing the user the time spent on this page
  // Updated - 20 Nov 2025 - scroll control


  // 1 - State variables
  const [showSections, setShowSections] = useState(false); // 29 Oct 2025
  const [showApproachSections, setShowApproachSections] = useState(false); // 31 Oct 2025

  // 2 - Timer - 02 Nov 2025
  useEffect(() => {
    if (typeof window !== "undefined") {
      // Always reset timer on new page load
      sessionStorage.setItem("trinity.startTime", Date.now().toString());
    }
  }, []);
  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     const alreadySet = sessionStorage.getItem("trinity.startTime");
  //     if (!alreadySet) {
  //       sessionStorage.setItem("trinity.startTime", Date.now().toString());
  //     }
  //   }
  // }, []);

  // 3 - Scroll to top on reload
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 20 Nov 2025 - Added to scroll to the right section
  useEffect(() => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash;
      if (hash) {
        const el = document.querySelector(hash);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 100); 
        }
      }
    }
  }, []);



  return (
    <div className="font-poppins">
      <EtHeader variant="trinity"/>
      <EtHero onContinue={() => setShowSections(true)} />
      {showSections && (
        <>
        <EtTrinityAdvantage onNext={() => setShowApproachSections(true)}/>
        
        {showApproachSections && (
          <>
            <EtHowItWorks />
            <EtTestimonials />
            <EtContact />
          </>
        )} 
        {/* <EtCallToAction /> */}
        {/* <EtAbout /> */}
        
        </>)}
      <EtFooter variant="trinity"/>
    </div>
  );
}
